<template>
  <div class="question-add">
    <p class="title">{{ titleMsg }}</p>
    <el-form class="form" size="small" label-position="right" label-width="120px" :rules="rules" :model="groupForm"
      ref="groupForm">
      <el-row>
        <el-col>
          <el-form-item label="所属小班：" prop="smallClassId" v-if="isSamllClass">
            <el-select class="select-content" v-model="groupForm.smallClassId" placeholder="请选择所属小班"
              :disabled="onlyLook">
              <el-option v-for="(item, i) in smallClassNameList" :key="i" :label="item.classChildName"
                :value="item.uuid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="班组名称：" prop="groupName">
            <el-input v-model="groupForm.groupName" placeholder="请输入班组名称" :disabled="onlyLook"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="24" v-if="isConvene">
          <el-form-item label="自习室：" prop="roomId">
            <load-select
              class="form-select"
              v-model="groupForm.roomId"
              dictLabel="teachingLocation"
              dictValue="uuid"
              :data="studyRoomData"
              :page="page"
              :hasMore="more"
              :request="getData"
              @change="setChange"
              :defaultVal="groupForm.studyRoom"
              placeholder="请选择地点（输入地点关键字以查询）"
              :isInit="isSetInit"
              :isAllowCreate="true"
              @ChangeValue="changeValue"
            />
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row>
        <el-col>
          <el-form-item label="班组组长：" prop="leaderUserName">
            <el-input
              readonly
              v-model="groupForm.leaderUserName"
              placeholder="请从下方列表中选择一个成员作为组长"
              :disabled="onlyLook"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <div v-if="isConvene">
        <el-row style="margin-top: 28px" v-show="!onlyLook">
          <el-col :span="10" class="right-wrap" style="float: right">
            <div class="btn-div">
              <el-checkbox :disabled="dragLiaDisabled" v-model="liaDragaable" class="drag-box mr16">拖拽排序</el-checkbox>
              <el-button class="mr16" :disabled="liaisonIds.length == 0" size="small"
                @click="deleteGroupLiaison">批量移除</el-button>
              <el-button type="primary" size="small" @click="groupLiaisonManage">选择</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="分组联络员列表：">
              <div class="liaison-table">
                <GroupLiaisonTable :class="{ 'list-drag': liaDragaable }" :data="groupForm.userList"
                  @selection-change="selectLiaisonChange" @editRoomNumber="showRoomNumber" @delLiaison="delLiaison"
                  :onlyLook="onlyLook" :isConvene="isConvene" row-key="uuid"></GroupLiaisonTable>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row style="margin-top: 28px" v-show="!onlyLook">
        <el-col :span="10" class="right-wrap" style="float: right">
          <div class="btn-div">
            <el-checkbox :disabled="dragDisabled" v-model="dragaable" class="drag-box mr16">拖拽排序</el-checkbox>
            <el-button class="mr16" :disabled="userIds.length == 0" size="small"
              @click="deleteGroupUsers">批量移除</el-button>
            <el-button type="primary" size="small" @click="groupUserManage">组员管理</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="组员列表：">
            <div class="group_table">
              <Table :class="{ 'list-drag': dragaable }" :data="groupForm.groupUserList"
                @selection-change="selectChange" @setLeaderUser="setLeaderUser" @deleteLeaderUser="deleteLeaderUser"
                row-key="enrollId" :onlyLook="onlyLook" :isConvene="isConvene"></Table>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col v-if="isConvene">
          <el-form-item label="召集人：" prop="leaderName">
            <el-input v-model="groupForm.leaderName" maxlength="50" placeholder="请选择召集人" :disabled="onlyLook"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="dialog-footer" label-width="0">
            <el-button @click="resetForm" v-show="!onlyLook">重置</el-button>
            <!-- <el-button @click="$router.back()">返回</el-button> -->
            <back-button :floatLeft="false" />
            <el-button type="primary" @click="submit" v-show="!onlyLook">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <UserManage :smallClassId="this.groupForm.smallClassId" />
    <GroupLiaisonDia :classId="classId" @addSucceed="addGroupLiaison" :defaultCheckedKeys="groupForm.userList"
      :showGroupLiaisonDia="showGroupLiaisonDia" v-if="showGroupLiaisonDia.flag" @closeDia="closeGroupLiaisonDia" />
    <room-number-dia :dialogInfo="roomNumberInfo" @closeDia="closeRoomDia" @changeRoomNumber="changeRoomNumber"
      v-if="roomNumberInfo.show" />
  </div>
</template>

<script>
import { getGroupInfo, saveGroup, updateGroup } from "@/api/enrollment";
import { smallClassList } from "@/api/groupManage";
import BackButton from "@/components/backButton/index";
import { Confirm } from "@/components/Confirm";
import vue from "@/main";
import { CONVENE_CLASSES } from "@/utils/constants.js";
import Sortable from "sortablejs";
import Table from "./table.js";
import UserManage from "./userManage.vue";
import GroupLiaisonTable from "./groupLiaisonTable.js";
import GroupLiaisonDia from "./groupLiaisonDia.vue";
import RoomNumberDia from "./roomNumberDia.vue";
// import LoadSelect from "@/components/load-select/index.vue";
import { classRoomPage } from "@/api/class";

export default {
  components: { Table, UserManage, BackButton, GroupLiaisonTable, GroupLiaisonDia, RoomNumberDia },
  data() {
    return {
      isConvene: false,
      leaderUserIds: [], // 组长或召集人id
      isSamllClass: 0,
      dragaable: false, //控制拖拽排序,
      liaDragaable: false, //控制分组联络员拖拽排序,
      titleMsg: "添加分组",
      classId: "",
      editId: null,
      onlyLook: false,
      groupForm: {
        groupName: "",
        leaderUserName: "",
        groupUserList: [],
        classPost: "",
        smallClassId: "",
        userList: [],
        leaderName: ""
      },
      pathOptions: {},
      checkArray: [],
      checkLiaisonArray: [],
      rules: {
        smallClassId: [
          {
            required: true,
            message: "请选择所属小班",
            trigger: ["blur", "change"],
          },
        ],
        groupName: [
          {
            required: true,
            message: "请输入班组名称",
            trigger: ["blur", "change"],
          },
          { min: 0, max: 50, message: "最多输入50个字", trigger: "change" },
        ],
        roomId: [
          { min: 0, max: 50, message: "最多输入50个字", trigger: "change" },
        ],
        leaderUserName: [
          {
            required: true,
            message: "请选择班组组长",
            trigger: ["blur", "change"],
          },
          { min: 0, max: 50, message: "最多输入50个字", trigger: "change" },
        ],
        classPost: [
          {
            required: true,
            message: "请输入班内职务",
            trigger: ["change", "blur"],
          },
        ],
      },
      smallClassNameList: [],
      showGroupLiaisonDia: {
        flag: false
      },
      roomNumberInfo: {
        title: "修改房间号",
        show: false,
        index: null,
        roomNumber: null
      },
      more: true,
      page: 1,
      studyRoomData: [],
      isSetInit: true,
      leaderUserNamesArr: []
    };
  },
  computed: {
    userIds() {
      return this.checkArray.map((item) => item.uuid);
    },
    liaisonIds() {
      return this.checkLiaisonArray.map((item) => item.uuid);
    },
    // 分组联络员
    dragLiaDisabled() {
      if (this.groupForm.userList && this.groupForm.userList.length < 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.liaDragaable = false;
        return true;
      }
      return false;
    },
    // 组员列表
    dragDisabled() {
      if (this.groupForm.groupUserList && this.groupForm.groupUserList.length < 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    },
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
    liaDragaable(val) {
      this.liaRowDrop(val);
    },
    leaderUserNamesArr() {
      this.groupForm.leaderName = this.leaderUserNamesArr.join('、');
    }
  },

  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     // from.path.indexOf("/onlineClass/groupList") != -1
  //     if (from.path.indexOf("/offlineClass/groupList") != -1) {
  //       vm.pathOptions = {
  //         path: from.path,
  //         query: from.query
  //       }
  //     }
  //   });
  // },

  created() {
    let { isSamllClass, classId, id, onlyLook, trainTypeName } =
      this.$route.query;
    this.isConvene = CONVENE_CLASSES.includes(trainTypeName);
    this.isSamllClass = Number(isSamllClass) || 0;
    this.classId = classId;
    this.editId = id;
    if (onlyLook) {
      this.onlyLook = true;
    }
    if (this.editId) {
      this.titleMsg = !!this.onlyLook ? "分组详情" : "编辑分组";
      this.getGroupInfo();
    }
    vue.$on("removeGroupUser", (item) => {
      this.removeGroupUser(item);
    });
    vue.$on("addGroupUsers", (groupUserList) => {
      this.addGroupUsers(groupUserList);
    });
    if (this.isSamllClass) {
      smallClassList({ classId: this.classId }).then(({ code, data }) => {
        if (code !== 0) return;
        this.smallClassNameList = data;
      });
    }
    
    
  },
  methods: {
    // 下拉加载
    setChange() {
      this.isSetInit = false;
    },
    // 选择自习室
    changeValue(val) {
      if (!!val) {
        let item = this.studyRoomData.filter((item) => item.uuid == val)[0];
        if (!item) {
          this.groupForm.studyRoom = val;
        } else {
          this.groupForm.studyRoom = item.teachingLocation;
        }
      } else {
        this.groupForm.studyRoom = ""
      }
    },
    // 下拉加载自习室
    getData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        classRoomPage({ page, teachingLocation: keyword }).then(({ code, data }) => {
          if (code !== 0) return;
          if (more) {
            this.studyRoomData = [...this.studyRoomData, ...data.records];
          } else {
            this.studyRoomData = data.records;
          }
          this.page = data.current;
          let { current, total, size } = data;
          this.more = current * size < total;
          this.page = current;
          resolve();
        });
      });
    },
    // 关闭选择分组联络员 弹窗
    closeGroupLiaisonDia() {
      this.showGroupLiaisonDia = { flag: false };
    },
    // 选择分组联络员
    addGroupLiaison(list) {
      this.showGroupLiaisonDia = { flag: false };
      this.groupForm.userList = [...list, ...this.groupForm.userList];
    },
    // 修改房间号
    showRoomNumber(vo) {
      const index = vo.$index
      let { roomNumber } = vo.row;
      this.roomNumberInfo.show = true;
      this.roomNumberInfo.roomNumber = roomNumber;
      this.roomNumberInfo.index = index;
    },
    changeRoomNumber(val) {
      let i = this.roomNumberInfo.index;
      this.groupForm.userList[i].roomNumber = val;
      this.roomNumberInfo.show = false;
    },
    closeRoomDia() {
      this.roomNumberInfo.show = false;
    },
    // 删除分组联络员
    async delLiaison(vo) {
      try {
        await Confirm(`确认移除该联络员吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        const index = vo.$index
        this.groupForm.userList.splice(index, 1);
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 批量删除分组联络员
    deleteGroupLiaison() {
      this.$confirm(`确认批量移除选中的吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          for (let i = 0; i < this.checkLiaisonArray.length; i++) {
            let userList = this.groupForm.userList;
            userList.splice(this.checkLiaisonArray[i], 1);
          }
        })
        .catch(() => { });
    },
    // 取消召集人
    deleteLeaderUser(vo) {
      let { $index: index, row } = vo;
      let tempRow = JSON.parse(JSON.stringify(row));
      tempRow["groupPostName"] = "";
      this.groupForm.groupUserList.splice(index, 1, tempRow);
      let delIndex = this.leaderUserIds.indexOf(row.enrollId);
      if (delIndex !== -1) {
        this.leaderUserIds.splice(delIndex, 1);
      }
      this.getLeaderUserNames(tempRow, 2);
    },
    // 分组详情
    getGroupInfo() {
      getGroupInfo(this.editId).then((res) => {
        if (!res || res.code != 0) return;
        this.groupForm = res.data;
        this.groupForm.userList = res.data.userList || [];
        this.leaderUserIds = res.data.leaderUserIds || [];
        if (res.data.leaderName && res.data.leaderName.length > 0) {
          this.leaderUserNamesArr = this.groupForm.leaderName.split('、');
        }
      });
    },
    addGroupUsers(groupUserList) {
      this.groupForm.groupUserList = groupUserList;
    },
    // 移除组员
    async removeGroupUser(item) {
      try {
        await Confirm(`确认移除该学员吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        let groupUserList = this.groupForm.groupUserList;
        groupUserList.splice(groupUserList.indexOf(item), 1);
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 设置组长
    setLeaderUser(vo) {
      let { $index: index, row } = vo;
      let tempRow = JSON.parse(JSON.stringify(row));
      if (row.groupPostName === "组长") return;
      if (!this.isConvene && this.editId) {
        let beforeIndex = this.groupForm.groupUserList.map(x => x.groupPostName).indexOf('组长');
        let beforeRow = JSON.parse(JSON.stringify(this.groupForm.groupUserList[beforeIndex]))
        beforeRow['groupPostName'] = ''
        this.groupForm.groupUserList.splice(beforeIndex, 1, beforeRow)
      }
      tempRow["groupPostName"] = this.isConvene ? "召集人" : "组长";
      this.groupForm.groupUserList.splice(index, 1, tempRow);
      if (this.isConvene) {
        this.leaderUserIds.push(row.enrollId);
      } else {
        let startIndex = this.groupForm.groupUserList
          .map((x) => x.enrollId)
          .indexOf(this.leaderUserIds[0]);
        if (startIndex !== -1) {
          let nowRow = JSON.parse(
            JSON.stringify(this.groupForm.groupUserList[startIndex])
          );
          nowRow["groupPostName"] = "";
          this.groupForm.groupUserList.splice(startIndex, 1, nowRow);
        }
        this.leaderUserIds = [row.enrollId];
      }
      this.getLeaderUserNames(tempRow, 1);
    },
    // 获取召集人
    getLeaderUserNames(row, type) {
      if (this.isConvene) {
        if (type == 1) {
          // 新增
          let length = this.leaderUserNamesArr.length;
          this.leaderUserNamesArr.splice(length, 1, row.userName);
        } else if (type == 2) {
          // 删除
          if (this.leaderUserNamesArr.indexOf(row.userName) > -1) {
            let index = this.leaderUserNamesArr.indexOf(row.userName);
            this.leaderUserNamesArr.splice(index, 1);
          }
        }
      } else {
        this.leaderUserNamesArr = [row.userName];
      }
    },
    // 拖拽排序
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".group_table .el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          onEnd({ oldIndex, newIndex }) {
            const currRow = _this.groupForm.groupUserList.splice(
              oldIndex,
              1
            )[0];
            _this.groupForm.groupUserList.splice(newIndex, 0, currRow);
          },
        });
      }
    },
    // 分组联络员拖拽排序
    liaRowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".liaison-table .el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          onEnd({ oldIndex, newIndex }) {
            const currRow = _this.groupForm.userList.splice(
              oldIndex,
              1
            )[0];
            _this.groupForm.userList.splice(newIndex, 0, currRow);
          },
        });
      }
    },
    // 分组联络员管理
    groupLiaisonManage() {
      this.showGroupLiaisonDia = { flag: true };
    },
    // 班委管理
    groupUserManage() {
      if (this.isSamllClass == 1 && !this.groupForm.smallClassId) {
        this.$message.warning("请先选择所属小班！");
        return;
      }
      vue.$emit(
        "groupUserManage",
        this.$route.query.id,
        this.groupForm.groupUserList
      );
    },
    resetForm() {
      this.$refs["groupForm"].resetFields();
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    selectLiaisonChange(selections) {
      this.checkLiaisonArray = selections;
    },
    // 批量删除
    deleteGroupUsers() {
      this.$confirm(`确认批量移除选中的学员吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          for (let i = 0; i < this.checkArray.length; i++) {
            let groupUserList = this.groupForm.groupUserList;
            groupUserList.splice(this.checkArray[i], 1);
          }
        })
        .catch(() => { });
    },
    // 处理分组联络员列表数据
    handleLiaisonUserList() {
      let userList = this.groupForm.userList || [];
      this.groupForm.userList = userList.map(item => {
        return {
          uuid: item.uuid,
          userName: item.userName,
          userMobile: item.userMobile,
          unitPosition: item.unitPosition,
          roomNumber: item.roomNumber
        }
      });
    },
    //更新分组
    submit() {
      if (!this.isConvene && this.leaderUserIds.length === 0) {
        this.$message.warning(`请设置组长`);
        return;
      }
      this.$refs["groupForm"].validate().then(() => {
        if (this.groupForm.groupUserList && this.groupForm.groupUserList) {
          this.groupForm.enrollIdList = this.groupForm.groupUserList.map(
            (item) => item.enrollId
          );
        } else {
          this.groupForm.enrollIdList = [];
        }
        let params = Object.assign({}, this.groupForm);
        params.classId = this.classId;
        params.isOnline = this.$route.query.isOnline;
        params.leaderUserIds = this.leaderUserIds;
        if (!!params.roomId) {
          delete params.roomId;
        }
        if (this.isConvene) {
          this.handleLiaisonUserList();
          params.userList = this.groupForm.userList;
        }
        if (this.editId) {
          updateGroup(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: "分组修改成功！",
              type: "success",
            });
            this.back()
          });
        } else {
          saveGroup(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: "添加成功！",
              type: "success",
            });
            this.back()
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.question-add {
  $textColor: #51627d;
  $textSize: 12px;

  @mixin text {
    color: $textColor;
    font-size: $textSize;
  }

  /deep/ .el-dialog__body {
    padding: 30px 30px 30px 20px;
  }

  .form {
    padding: 10px 20px;
  }

  .title {
    color: #343c4a;
    font-size: 16px;
    margin: 0;
    padding: 14px 0 10px 34px;
    border-bottom: 1px solid #edf1f8;
  }

  .delete-choose {
    position: absolute;
    top: 10px;
    right: -19px;
    font-size: 14px;
    cursor: pointer;
  }

  .form-select {
    width: 100%;

    &.has-btn {
      width: calc(100% - 120px);
    }
  }

  .mr16 {
    margin-right: 16px;
  }
}

.btn-div {
  float: right;

  /deep/ .drag-box {
    .el-checkbox__label {
      font-size: 12px;
      color: #51627d;
      font-weight: normal;
    }
  }
}

.dialog-footer {
  text-align: center;
}

.right-wrap {
  float: right;
  margin-bottom: 18px;
}

.select-content {
  width: 100% !important;
}
</style>
